/* eslint-disable no-inline-comments */
/* eslint-disable consistent-return */
/* eslint-disable no-undefined */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React from 'react'
import ReactDOM from 'react-dom'
// import DataTable from "react-data-table-component";
import MUIDataTable from 'mui-datatables'
import {
  createTheme,
  MuiThemeProvider,
  getMuiTheme,
  withStyles
} from '@material-ui/core/styles'
// import "./styles.css";
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  getTopLeadersFromProps,
  getAllCompanySettings,
  getAllGeneralSettings,
  getTopLeaders
  // keepTopLeaders
} from '../../store/actions/companyAdminActions'
// import {
//   leaderboardAll
// } from '../../store/actions/leaderboardActions'
import {
  Avatar
} from '@material-ui/core'
import { PHOTO_PROFILE } from '../../utils/photo_utils'
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  Grid
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import {
  GET_ALL_COMPANY_SETTINGS,
  GET_ALL_GENERAL_SETTINGS,
  LEADERBOARD,
  SHOW_TOAST,
  GET_ALL_COMPANY_USERS
} from '../../store/actions/types'
import { Container, Row, Col } from 'react-grid-system'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
import LoaderBar from '../../components/LoaderBar'
import FinalScope from '../../pages/PointsSurveys/FinalScope'
import { showToast } from '../../store/actions/toastAction'
import ToggleButton from 'react-toggle-button'
import ViewUser from '../UserProfile/ViewUser'
import ViewUser_self from '../UserProfile/ViewUser_self'
import ViewUser_ledain from '../UserProfile/ViewUser_ledain'
import ViewUser_gen from '../UserProfile/ViewUser_gen'
//import ViewUser_ledain_self from '../UserProfile/ViewUser_ledain_self'
import ViewUser_self_gen from '../UserProfile/ViewUser_self_gen'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import GenTutorial from '../../pages/PointsSurveys/GenTutorial'
import { getCompanyValues } from '../../store/actions/pldpActions'
import { scopedCssBaselineClasses } from '@mui/material'
import { SettingsBrightnessSharp } from '@material-ui/icons'
//import { GrSupport } from "react-icons/gr";
import { BiBi } from "react-icons/bi";

// Mobile-specific styles for compact leaderboard
const mobileStyles = `
  .mobile-leaderboard .MUIDataTable-root {
    backgroundColor: transparent;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  .mobile-leaderboard .MUIDataTableBodyCell-root {
    padding: 2px 3px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1.3 !important;
    border-bottom: 1px solid #f0f0f0 !important;
    vertical-align: middle !important;
  }
  .mobile-leaderboard .MUIDataTableHeadCell-root {
    padding: 4px 3px !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    background-color: #2c5aa0 !important;
    border-bottom: 1px solid #1e3d6f !important;
    color: white !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .mobile-leaderboard .MUIDataTableBodyRow-root {
    height: 38px !important;
    min-height: 38px !important;
  }
  .mobile-leaderboard .MUIDataTableBodyRow-root:nth-child(even) {
    background-color: #f8f9fa !important;
  }
  .mobile-leaderboard .MUIDataTableBodyRow-root:hover {
    background-color: #e3f2fd !important;
  }
  .mobile-leaderboard .MUIDataTable-paper {
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
    border: 1px solid #e9ecef !important;
    border-radius: 12px !important;
    overflow: hidden;
  }
  .mobile-leaderboard .MUIDataTableToolbar-root {
    min-height: 32px !important;
    padding: 2px 6px !important;
    background-color: #f8f9fa !important;
  }
  .mobile-leaderboard .MUIDataTablePagination-root {
    padding: 2px 6px !important;
    background-color: #f8f9fa !important;
    border-top: 1px solid #e9ecef !important;
  }
  .mobile-leaderboard .MUIDataTablePagination-tableCellContainer {
    padding: 2px !important;
  }
  .mobile-leaderboard .MUIDataTablePagination-selectRoot {
    font-size: 12px !important;
  }
  .mobile-leaderboard .MUIDataTablePagination-displayedRows {
    font-size: 11px !important;
  }
  .mobile-leaderboard .MUIDataTableFilter-root {
    padding: 6px !important;
  }
  .mobile-leaderboard .MUIDataTableSearch-main {
    padding: 2px 6px !important;
  }
  .mobile-leaderboard .MUIDataTableSearch-searchText {
    font-size: 12px !important;
  }
`;

// Inject styles
if (isMobile && typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = mobileStyles;
  document.head.appendChild(style);
}

class LeaderOnList extends React.Component {
  constructor(props) {
    super(props)
         try {
      
    }
    catch(err) {
      }

  }
   state = {
     // users: this.props.location.state.Everyone ? this.props.location.state.Everyone : null,
     uid: '',
     leaderboardKey: '',
     userID: '',
     selectedSector: 'x',
     selectedCountry: 'x',
     selectedClub: this.props.userdata.companyID,
     selectedPostion: 'x',
     leaderboardData: {},
     togglePoints: false,
     loading: false
   };

   componentDidMount() {
    
    this.setState({ loading: true });
    
    // Check if we already have data in props
    if (this.props.leaderboardData && Object.keys(this.props.leaderboardData).length > 0) {
      
      this.processLeaderboardData();
      return;
    }

    try {
      const cachedUsers = localStorage.getItem('leaderboardUsers');
      const cachedData = localStorage.getItem('leaderboardData');
      const cachedAtStr = localStorage.getItem('leaderboardCacheAt');

      // 10 minutes TTL to avoid stale desktop data
      const TTL_MS = 10 * 60 * 1000;
      const now = Date.now();
      const isFresh = cachedAtStr ? (now - Number(cachedAtStr)) < TTL_MS : false;

      if (cachedUsers && cachedData) {
        // Hydrate from cache for instant paint
        this.props.dispatch({ type: GET_ALL_COMPANY_USERS, users: JSON.parse(cachedUsers) });
        this.props.dispatch({ type: LEADERBOARD, leaderboard_action: JSON.parse(cachedData) });

        // Process the cached data quickly
        setTimeout(() => { this.processLeaderboardData(); }, 50);
      }

      // Always kick off a background refresh to reconcile differences
      // If cache is missing or stale, this ensures latest data replaces it
      if (!cachedUsers || !cachedData || !isFresh) {
        this.props.getTopLeaders({ firstOrder: false });
      }
    } catch (error) {
      // On any cache error, fetch live data
      this.props.getTopLeaders({ firstOrder: false });
    }
   }

   componentDidUpdate(prevProps) {
    
    
    
    
    // Save data to cache when updated
    if (this.props.users && prevProps.users !== this.props.users) {
      try {
        localStorage.setItem('leaderboardUsers', JSON.stringify(this.props.users));
        localStorage.setItem('leaderboardCacheAt', String(Date.now()));
      } catch (e) { }
    }

    if (this.props.leaderboardData && prevProps.leaderboardData !== this.props.leaderboardData) {
      try {
        localStorage.setItem('leaderboardData', JSON.stringify(this.props.leaderboardData));
        localStorage.setItem('leaderboardCacheAt', String(Date.now()));
      } catch (error) { }
      this.processLeaderboardData();
    }
   }

   processLeaderboardData = () => {
     
     
     
     
     if (!this.props.leaderboardData) {
       
       this.setState({ loading: false });
       return;
     }
     
     let leaderboardMData = {};
     let lkey;

     if (this.props.location && this.props.location.state && this.props.location.state.Everyone) {
       lkey = this.props.userdata.companyID + '=x=x=x';
     } else if (this.state.leaderboardKey) {
       lkey = this.state.leaderboardKey;
     } else {
       lkey = this.props.userdata.companyID + '=x=x=x';
     }

     
     leaderboardMData = JSON.parse(JSON.stringify(this.props.leaderboardData));

     this.props.getTopLeadersFromProps({
       Alldata: leaderboardMData,
       companyID: this.props.userdata.companyID,
       orderChild: 'LeaderboardKey',
       LeaderboardKey: lkey,
       firstOrder: false,
       pointsy: this.state.togglePoints
     });

     this.props.getAllCompanySettings({
       companyID: '-Lu4BlhZ-tsDSnd-fnFd'
     });
     this.props.getAllGeneralSettings({
       companyID: this.props.userdata.companyID
     });

     if (isBrowser) {
       this.transformTableData();
     } else {
       this.transformTableData_m();
     }
     
     this.setState({ loading: false });
   };

   clearEmptyStrings(obj) {
     Object.keys(obj).forEach(key => {
       if (typeof obj[key] === 'object') {
         return obj[key]
       }
       if (obj[key] === '') {
         delete obj[key]
       }
     })
   }

  //  columns = this.state.togglePoints ? [
  //   'No', 'Avatar', 'Lastname', 'Sector', 'Country', 'Club', 'Position', 'Year Points']
  //    : ['No', 'Avatar', 'Name', 'Lastname', 'Sector', 'Country', 'Club', 'Position', 'Points', 'RFeedback', 'Feedback']


   columns = this.state.togglePoints ? 
   [ 
    {
      name: "No",
      options: {
        filter: true,
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            left: "0",
            background: "white",
            width: "5%",
            maxWidth: "10%",
            zIndex: 100
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            left: 0,
            background: "white",
            zIndex: 101
          }
        })
      }
    },
    {
      name: "Avatar",
      flex: 1,
      options: {
        filter: true,
        setCellProps: () => ({ style: { whiteSpace: "nowrap", width: '5%' } })
      }
    },
    {
      name: "Name",
      flex: 1,
      options: {
        filter: true,
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
      }
    },
    {
      name: "Lastname",
      flex: 1,
      options: {
        filter: true,
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
      }
    },
    {
      name: "Sector",
      flex: 1,
      options: {
        filter: true,
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
      }
    },
    {
      name: "Country",
      flex: 1,
      options: {
        filter: true,
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
      }
    },
    {
      name: "Club",
      flex: 1,
      options: {
        filter: true,
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
      }
    },
    {
      name: "Position",
      flex: 1,
      options: {
        filter: true,
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
      }
    },
    {
      name: "Year Lc",
      flex: 1,
      options: {
        filter: true,
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
      }
    }]
   
     :
     [ 
      {
        name: "No",
        options: {
          filter: true,
          setCellProps: () => ({
            style: {
              whiteSpace: "nowrap",
              position: "sticky",
              left: "0",
              background: "white",
              zIndex: 100
            }
          }),
          setCellHeaderProps: () => ({
            style: {
              whiteSpace: "nowrap",
              position: "sticky",
              left: 0,
              background: "white",
              zIndex: 101
            }
          })
        }
      },
      {
        name: "Avatar",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "Name",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "Lastname",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "Sector",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "Country",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "Forum",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "Position",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "Lc",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      // {
      //   name: "n",
      //   flex: 1,
      //   options: {
      //     filter: true,
      //     setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
      //   }
      // },
      {
        name: "G-FB",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "R-FB",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      },
      {
        name: "Feedback",
        flex: 1,
        options: {
          filter: true,
          setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
        }
      }
    ]   

     // Mobile columns - optimized for the 6 essential fields
  columnsm = [
    {
      name: "#",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ 
          style: { 
            width: '30px', 
            textAlign: 'center', 
            padding: '3px 2px',
            fontSize: '14px',
            fontWeight: '700'
          } 
        }),
        customBodyRender: (value) => (
          <div style={{
            width: '28px', height: '28px', lineHeight: '28px',
            borderRadius: '50%', textAlign: 'center',
            background: '#cdbc74', color: '#fff', fontWeight: 'bold'
          }}>{value}</div>
        ),
        setCellHeaderProps: () => ({
          style: {
            width: '30px',
            textAlign: 'center',
            padding: '3px 2px',
            fontSize: '12px',
            fontWeight: '700'
          }
        })
      }
    },
    {
      name: "Name",
      options: {
        filter: true,
        setCellProps: () => ({ 
          style: { 
            width: '75px', 
            padding: '3px 4px'
          } 
        }),
        customBodyRender: (value) => (
          <div style={{ fontSize: '14px', fontWeight: 600, color: '#333', lineHeight: '1.3', maxWidth: '85px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div>
        ),
        setCellHeaderProps: () => ({
          style: {
            width: '75px',
            padding: '3px 4px',
            fontSize: '12px',
            fontWeight: '700'
          }
        })
      }
    },
    {
      name: "Lastname",
      options: {
        filter: true,
        setCellProps: () => ({ 
          style: { 
            width: '75px', 
            padding: '3px 4px'
          } 
        }),
        customBodyRender: (value) => (
          <div style={{ fontSize: '14px', fontWeight: 600, color: '#333', lineHeight: '1.3', maxWidth: '85px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div>
        ),
        setCellHeaderProps: () => ({
          style: {
            width: '75px',
            padding: '3px 4px',
            fontSize: '12px',
            fontWeight: '700'
          }
        })
      }
    },
    {
      name: "Country",
      options: {
        filter: true,
        setCellProps: () => ({ 
          style: { 
            width: '55px', 
            textAlign: 'center', 
            padding: '3px 2px'
          } 
        }),
        customBodyRender: (value) => (
          <div style={{ fontSize: '13px', fontWeight: 500, color: '#666', textAlign: 'center', maxWidth: '65px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div>
        ),
        setCellHeaderProps: () => ({
          style: {
            width: '55px',
            textAlign: 'center',
            padding: '3px 2px',
            fontSize: '12px',
            fontWeight: '700'
          }
        })
      }
    },
    {
      name: "Level",
      options: {
        filter: true,
        setCellProps: () => ({ 
          style: { 
            width: '50px', 
            textAlign: 'center', 
            padding: '3px 2px'
          } 
        }),
        customBodyRender: (value) => (
          <div style={{ fontSize: '13px', fontWeight: 600, color: '#666', textAlign: 'center', maxWidth: '65px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div>
        ),
        setCellHeaderProps: () => ({
          style: {
            width: '50px',
            textAlign: 'center',
            padding: '3px 2px',
            fontSize: '12px',
            fontWeight: '700'
          }
        })
      }
    },
    {
      name: "Lc",
      options: {
        filter: false,
        sort: true,
        // Render LC with style but keep underlying value numeric for sorting
        customBodyRender: (value) => (
          <div style={{ 
            fontSize: '14px', 
            fontWeight: 700, 
            color: '#2c5aa0', 
            textAlign: 'center' 
          }}>
            {Number(value)}
          </div>
        ),
        setCellProps: () => ({ 
          style: { 
            width: '45px', 
            textAlign: 'center', 
            padding: '3px 2px'
          } 
        }),
        setCellHeaderProps: () => ({
          style: {
            width: '45px',
            textAlign: 'center',
            padding: '3px 2px',
            fontSize: '12px',
            fontWeight: '700'
          }
        })
      }
    },
    {
      name: "Feedback",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ 
          style: { 
            width: '60px', 
            textAlign: 'center', 
            padding: '3px 2px'
          } 
        }),
        customBodyRender: (value) => (
          <div style={{ fontSize: '13px', textAlign: 'center', color: value !== 'n/a' ? '#4caf50' : '#999', fontWeight: value !== 'n/a' ? '600' : '500' }}>{value}</div>
        ),
        setCellHeaderProps: () => ({
          style: {
            width: '60px',
            textAlign: 'center',
            padding: '3px 2px',
            fontSize: '12px',
            fontWeight: '700'
          }
        })
      }
    }
  ]


    renderGeneralSettings = (type) => {
      let itemdata = null
      if (this.props.general_settings && this.props.general_settings[type]) {
        itemdata = this.props.general_settings[type]
        //itemdata.sort()
        return itemdata.map((v, i) => (
          <option key={i} value={v}>
            {v}
          </option>
        ))
      }
    };

   filterZZZ = (comLable) => {
     let comLablex = comLable.toString()
     let myTruncatedString = comLablex.substring(0, 4)
     let finalstring = comLablex

     if (myTruncatedString === 'ZZZ_') {
       finalstring = comLablex.substring(4, comLablex.length)
     }
     if (myTruncatedString === 'AAA_') {
       finalstring = comLablex.substring(4, comLablex.length)
     }
     return finalstring
   };

   // Build sector list from actual data so filtering matches table values
   getSectorOptions = () => {
     const sectorsMap = new Map()
     const { company_settings, companyValues, leaderboardData } = this.props
     const { selectedClub, selectedCountry, selectedPostion } = this.state

     const add = (raw) => {
       if (!raw || typeof raw !== 'string') return
       const label = this.filterZZZ(raw).trim()
       if (label) sectorsMap.set(raw, label)
     }

     // 1) Prefer the unfiltered leaderboard dataset so options do not shrink after selection
     if (leaderboardData && typeof leaderboardData === 'object') {
       Object.keys(leaderboardData).forEach(k => {
         const u = leaderboardData[k]
         if (!u || typeof u !== 'object') return
         // Apply other filters (forum/country/position) but not sector
         if (selectedClub !== 'x' && u.companyID !== selectedClub) return
         if (selectedCountry !== 'x' && u.nationality !== selectedCountry) return
         if (selectedPostion !== 'x' && u.position !== selectedPostion) return
         add(u.department)
       })
     }

     // 2) Fallback to company settings if leaderboard not yet present
     if (sectorsMap.size === 0 && company_settings && company_settings['departments']) {
       const arr = company_settings['departments'] || []
       arr.forEach(v => add(v))
     }

     // 3) Fallback to companyValues (valueDesc) if needed
     if (sectorsMap.size === 0 && companyValues) {
       Object.keys(companyValues).forEach(id => {
         const rec = companyValues[id]
         const raw = rec && (rec.valueDesc || rec.label || rec.name)
         add(raw && String(raw))
       })
     }

     return Array.from(sectorsMap.entries())
       .sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }))
       .map(([value, label]) => ({ value, label }))
   }

   renderSectorOptions = () => {
     return this.getSectorOptions().map(opt => (
       <option key={opt.value} value={opt.value}>{opt.label}</option>
     ))
   }

    renderCompanySettings = (type) => {
      let itemdata = null
    if (this.props.company_settings && this.props.company_settings[type]) {
        itemdata = this.props.company_settings[type]
        // this.sortArray(itemdata);
        itemdata.sort()
        
        return itemdata.map((v, i) => (
         v !== 'Leading Self' && v !== 'Delivering Results' && v !== 'Relating to Others' && v !== 'Versatile Leader' ?
          <option key={i} value={v}>
            {this.filterZZZ(v)}
          </option>
          :null

        ))
      }
    };
    sortArray = (arr) => {
      arr.sort(function (a, b) {
        return a.length - b.length
      })
    }

    options={
      selectableRows: false,
      textLabels: {
        body: {
          noMatch: '',
          toolTip: 'Sort'
        },
        pagination: {
          next: "Next",
          previous: "Previous",
          rowsPerPage: "Rows:",
          displayRows: "of"
        }
      },
      pagination: true,
      rowsPerPage: isMobile ? 25 : 10,
      rowsPerPageOptions: isMobile ? [25, 50, 100] : [10, 25, 50, 100],
      responsive: 'standard',
      tableBodyHeight: isMobile ? '65vh' : 'auto',
      tableBodyMaxHeight: isMobile ? '65vh' : 'auto',
      selectToolbarPlacement: 'none',
      print: false,
      download: false,
      filter: !isMobile,
      search: !isMobile,
      viewColumns: !isMobile,
      sortFilterList: false,
      customToolbar: null,
      elevation: 0,
      fixedHeader: isMobile,
      fixedSelectColumn: false
    }

    handleChangeClub = event => {
      this.setState({
        selectedClub: event.target.value
      })
      this.loadLeaders('club', event.target.value)
    }

    handleChangeCountry = event => {
      this.setState({
        selectedCountry: event.target.value
      })
      this.loadLeaders('country', event.target.value)
    }

    handleChangePostion = event => {
      this.setState({
        selectedPostion: event.target.value
      })
      this.loadLeaders('position', event.target.value)
    }

    handleChangeSector = event => {
      this.setState({
        selectedSector: event.target.value
      })
      this.loadLeaders('sector', event.target.value)
    }

    // handleToggle = (val) => {
    //   var newval;
    //   if (val) {
    //     newval = false;
    //   }
    //   else
    //   {
    //     newval = true;
    //   }

    //   this.setState({
    //     togglePoints: newval,
    //   })
    //  this.loadLeaders('', newval);
    // }

    showdetails = () => {
      }

    // Mobile-optimized filter controls
    renderMobileFilters = () => {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          padding: '10px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          marginBottom: '12px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            fontSize: '14px'
          }}>
            <span style={{ fontWeight: '700', minWidth: '70px' }}>
              {this.state.togglePoints ? 'Annual:' : 'All-time:'}
            </span>
            <ToggleButton
              value={this.state.togglePoints || false}
              thumbStyle={{ borderRadius: '2px' }}
              trackStyle={{ borderRadius: '2px' }}
              onToggle={(value) => {
                this.setState({ togglePoints: !value })
                this.loadLeaders('pointsy', !value)
              }}
            />
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '10px'
          }}>
            <select 
              value={this.state.selectedClub} 
              onChange={this.handleChangeClub}
              style={{
                padding: '8px',
                fontSize: '14px',
                fontWeight: '600',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            >
              <option value={this.props.userdata.companyID}>Local Forum</option>
              <option value='x'>All Forums</option>
            </select>
            
            <select 
              value={this.state.selectedCountry} 
              onChange={this.handleChangeCountry}
              style={{
                padding: '8px',
                fontSize: '14px',
                fontWeight: '600',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            >
              <option value='x'>All Countries</option>
              {this.renderGeneralSettings('countriesb')}
            </select>
          </div>
        </div>
      )
    }

    loadLeaders = (crit, val) => {
      let { users, getTopLeadersFromProps, leaderboardData } = this.props
      let leaderboardKey
      let leaderboardMData = {}
      leaderboardMData = Object.assign({}, this.props.leaderboardData)
      let pp

      switch (crit) {
      case 'club':
        leaderboardKey = val + '=' + this.state.selectedCountry + '=' + this.state.selectedPostion + '=' + this.state.selectedSector
        pp = this.state.togglePoints
        break
      case 'country':
        leaderboardKey = this.state.selectedClub + '=' + val + '=' + this.state.selectedPostion + '=' + this.state.selectedSector
        pp = this.state.togglePoints
        break
      case 'position':
        leaderboardKey = this.state.selectedClub + '=' + this.state.selectedCountry + '=' + val + '=' + this.state.selectedSector
        pp = this.state.togglePoints
        break
      case 'sector':
        leaderboardKey = this.state.selectedClub + '=' + this.state.selectedCountry + '=' + this.state.selectedPostion + '=' + val
        pp = this.state.togglePoints
        break
      case 'pointsy':
        leaderboardKey = this.state.selectedClub + '=' + this.state.selectedCountry + '=' + this.state.selectedPostion + '=' + this.state.selectedSector
        pp = val
        break
      default:
        leaderboardKey = this.state.selectedClub + '=' + this.state.selectedCountry + '=' + this.state.selectedPostion + '=' + this.state.selectedSector
        pp = this.state.togglePoints
        break
      }
      // users[uid].feedbackOn && showGFeedback
      this.props.getTopLeadersFromProps({ // this.props.users
        Alldata: leaderboardMData,
        companyID: this.props.userdata.companyID,
        orderChild: 'LeaderboardKey',
        LeaderboardKey: leaderboardKey,
        firstOrder: false,
        pointsy: pp
      })

      this.setState({ leaderboardKey: leaderboardKey })
      // this.transformTableData();
      if (isBrowser) {
        this.transformTableData()
      } else {
        this.transformTableData_m()
      }
    }


    transformTableData = () => {
      let { classes, userdata, getAllCompanyUsers, users } = this.props
      let nr
      let showGFeedback
      var PointsDisplay;
      var pointsM;
      var ponitsY;
      var threeSixty;

      let objLeng = Object.keys(this.props.users).length
      
    let dataListClone = Object.keys(users).map((uid, index) => {
        if ( users[uid].eval360===true) {threeSixty = ' **'} else {threeSixty = ''}

        if (users[uid].pointsCalf) {
           var pointsM = (parseFloat(users[uid].points) + parseFloat(users[uid].pointsCalf))/100 
          var pointsY = (parseFloat(users[uid].pointsy) + parseFloat(users[uid].pointsCalf))/100 
        }
        else
        {
          var pointsM = ( parseFloat(users[uid].points) )/100 
          var pointsY = ( parseFloat(users[uid].pointsy) )/100
        }
        if (this.state.togglePoints) {
          PointsDisplay = pointsY
        }
        else
        {
          PointsDisplay = pointsM
        }

        if (users[uid].gfeedbackOn === false) { // show only if club id = logged in users club id
          if (users[uid].companyID === this.props.userdata.companyID) { // only show feedback here
            showGFeedback = true
          } else {
            showGFeedback = false
          }
        } else {
          showGFeedback = true
        }

        let ds = users[uid].dateRegistered
        nr = parseInt(uid) + parseInt(1)

        return [
          <div style={{
            width: '30px',
            height: '30px',
            lineHeight: '30px',
            borderRadius: '50%',
            fontSize: '14px',
            color: '#000',
            textAlign: 'center',
            background: '#cdbc74'
          }}>{nr}</div>,

       [users[uid].companyID==='-MloJFGCyJJbs_bNlwTg' && users[uid].userID!==this.props.userdata.userID ?
           <ViewUser_gen
            src={users[uid].photoURL}
            id={users[uid].uid}
            companyName={users[uid].companyName}
            leaderArr={this.props.userdata.leaderArr}
            leaderID={users[uid].userID}
            slaveID={this.props.userdata.userID}
            companyID={this.props.userdata.companyID}
            firstName={this.props.userdata.firstName}
            lastName={this.props.userdata.lastName}
            uid={this.props.userdata.uid}
            leaderUid={users[uid].uid}
           
            //points={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.points) + Number(this.props.userdata.pointsCalf))/100) : (Number(his.props.userdata.points)/100)}
            //pointsy={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.pointsy) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.pointsy)/100)}                     
             points={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.points) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.points)}
             pointsy={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.pointsy) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.pointsy)}          
            post={users[uid]}
            following={
              this.props.followingData
                ? this.props.followingData[users[uid].userID]
                  ? true
                  : false
                : false
            }
            journalUserID={users[uid].userID}
            userIDlogged={this.props.userdata.userID}
            evalNum={this.props.userdata.evalNum ? this.props.userdata.evalNum : 0}
            evalNumP={this.props.userdata.evalNumP ? this.props.userdata.evalNumP : 0}
            />
            :

      users[uid].companyID==='-MloJFGCyJJbs_bNlwTg' && users[uid].userID===this.props.userdata.userID ?
            <ViewUser_self_gen
             src={users[uid].photoURL}
             id={users[uid].uid}
             companyName={users[uid].companyName}
             leaderID={users[uid].userID}
             slaveID={this.props.userdata.userID}
             companyID={this.props.userdata.companyID}
             firstName={this.props.userdata.firstName}
             lastName={this.props.userdata.lastName}
             uid={this.props.userdata.uid}
             leaderUid={users[uid].uid}
          
            // points={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.points) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.points)/100)}
             //pointsy={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.pointsy) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.pointsy)/100)}               
             points={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.points) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.points)}
             pointsy={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.pointsy) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.pointsy)}          
             post={users[uid]}
             following={
               this.props.followingData
                 ? this.props.followingData[users[uid].userID]
                   ? true
                   : false
                 : false
             }
             journalUserID={users[uid].userID}
             userIDlogged={this.props.userdata.userID}
             />
             :
    users[uid].companyID!=='-MloJFGCyJJbs_bNlwTg' && users[uid].userID!==this.props.userdata.userID ?         
          // <ViewUser
          <ViewUser_gen
            src={users[uid].photoURL}
            id={users[uid].uid}
            companyName={users[uid].companyName}
            leaderArr={this.props.userdata.leaderArr}
            leaderID={users[uid].userID}
            slaveID={this.props.userdata.userID}
            companyID={this.props.userdata.companyID}
            firstName={this.props.userdata.firstName}
            lastName={this.props.userdata.lastName}
            uid={this.props.userdata.uid}
            leaderUid={users[uid].uid}
          
            //points={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.points) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.points)/100)}
           // pointsy={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.pointsy) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.pointsy)/100)}             
            points={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.points) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.points)}
            pointsy={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.pointsy) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.pointsy)}          
            post={users[uid]}
            following={
              this.props.followingData
                ? this.props.followingData[users[uid].userID]
                  ? true
                  : false
                : false
            }
            journalUserID={users[uid].userID}
            userIDlogged={this.props.userdata.userID}
            evalNum={this.props.userdata.evalNum ? this.props.userdata.evalNum : 0}
            evalNumP={this.props.userdata.evalNumP ? this.props.userdata.evalNumP : 0}
          /> 
          :
    users[uid].companyID!=='-MloJFGCyJJbs_bNlwTg' && users[uid].userID===this.props.userdata.userID ?         
          // <ViewUser_self
          <ViewUser_self_gen
            src={users[uid].photoURL}
            id={users[uid].uid}
            companyName={users[uid].companyName}
            leaderID={users[uid].userID}
            slaveID={this.props.userdata.userID}
            companyID={this.props.userdata.companyID}
            firstName={this.props.userdata.firstName}
            lastName={this.props.userdata.lastName}
            uid={this.props.userdata.uid}
            leaderUid={users[uid].uid}
           
            //points={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.points) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.points)/100)}
           // pointsy={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.pointsy) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.pointsy)/100)}             
            points={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.points) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.points)}
            pointsy={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.pointsy) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.pointsy)}          
            post={users[uid]}
            following={
              this.props.followingData
                ? this.props.followingData[users[uid].userID]
                  ? true
                  : false
                : false
            }
            journalUserID={users[uid].userID}
            userIDlogged={this.props.userdata.userID}
          /> :null
           ]
          ,
          users[uid].firstName ? users[uid].firstName : '',
          users[uid].lastName ? users[uid].lastName : '',
          users[uid].department ? users[uid].department : '',
          users[uid].nationality ? users[uid].nationality : '',
          users[uid].companyName ? users[uid].companyName : '',
          users[uid].position ? users[uid].position : '',
         PointsDisplay,
          // users[uid].evalNum ? users[uid].evalNum : '',
          users[uid].evalNumP ? users[uid].evalNumP : '',
          users[uid].feedbackOn && showGFeedback && users[uid].sfeedback && (users[uid].sfeedback !==0) && (users[uid].sfeedback !==1) ? users[uid].sfeedback : 'n/a',
          users[uid].feedbackOn && showGFeedback && users[uid].feedback && (users[uid].feedback !==0) && (users[uid].feedback !==1) ? users[uid].feedback + [threeSixty]: 'n/a',
          users[uid].uid ? users[uid].uid : '',
          users[uid].userID ? users[uid].userID : ''
        ]
      })
      return dataListClone
    };


    transformTableData_m = () => {
      let { classes, userdata, getAllCompanyUsers, users } = this.props
      let nr
      let showGFeedback
      var threeSixty;

      let objLeng = Object.keys(this.props.users).length

      let dataListClone = Object.keys(users).map((uid, index) => {
        if ( users[uid].eval360===true) {threeSixty = ' **'} else {threeSixty = ''}
        if (users[uid].gfeedbackOn === false) { // show only if club id = logged in users club id
          if (users[uid].companyID === this.props.userdata.companyID) { // only show feedback here
            showGFeedback = true
          } else {
            showGFeedback = false
          }
        } else {
          showGFeedback = true
        }

        let ds = users[uid].dateRegistered
        nr = parseInt(uid) + parseInt(1)

        // var imgURL = toString(users[uid].photoURL);
        // var imgURL2 = imgURL.replace(/\//g, "*");
        // var imgURL2 = 'https://firebasestorage.googleapis.com/v0/b/leadershipplatform-158316.appspot.com/o/appassets%2Fdefault-user.png?alt=media&token=7a1a942d-4a23-4ea4-aac5-cac77daebc40';
        // if (imgURL) {
        //   imgURL2 = imgURL //imgURL.replace(/\/?(\?|#|$)/, '/$1');
        // // imgURL2 = PHOTO_PROFILE(users[uid].photoURL)

        // };

        return [
          <div style={{
            width: '30px',
            height: '30px',
            lineHeight: '30px',
            borderRadius: '50%',
            fontSize: '14px',
            color: '#000',
            textAlign: 'center',
            background: '#cdbc74'
          }}>{nr}</div>,
          [users[uid].companyID==='-MloJFGCyJJbs_bNlwTg' && users[uid].userID!==this.props.userdata.userID ?
          // <ViewUser_ledain
          <ViewUser_gen
           src={users[uid].photoURL}
           id={users[uid].uid}
           companyName={users[uid].companyName}
           leaderArr = {this.props.userdata.leaderArr}
           leaderID={users[uid].userID}
           slaveID={this.props.userdata.userID}
           companyID={this.props.userdata.companyID}
           firstName={this.props.userdata.firstName}
           lastName={this.props.userdata.lastName}
           uid={this.props.userdata.uid}
           leaderUid={users[uid].uid}
         
          // points={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.points) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.points)/100)}
          // pointsy={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.pointsy) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.pointsy)/100)}            
           points={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.points) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.points)}
           pointsy={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.pointsy) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.pointsy)}          
           post={users[uid]}
           following={
             this.props.followingData
               ? this.props.followingData[users[uid].userID]
                 ? true
                 : false
               : false
           }
           journalUserID={users[uid].userID}
           userIDlogged={this.props.userdata.userID}
           evalNum={this.props.userdata.evalNum ? this.props.userdata.evalNum : 0}
           evalNumP={this.props.userdata.evalNumP ? this.props.userdata.evalNumP : 0}
           />
           :

     users[uid].companyID==='-MloJFGCyJJbs_bNlwTg' && users[uid].userID===this.props.userdata.userID ?
          // <ViewUser_ledain_self
          <ViewUser_self_gen
            src={users[uid].photoURL}
            id={users[uid].uid}
            companyName={users[uid].companyName}
            leaderID={users[uid].userID}
            slaveID={this.props.userdata.userID}
            companyID={this.props.userdata.companyID}
            firstName={this.props.userdata.firstName}
            lastName={this.props.userdata.lastName}
            uid={this.props.userdata.uid}
            leaderUid={users[uid].uid}
        
            //points={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.points) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.points)/100)}
            //pointsy={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.pointsy) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.pointsy)/100)}             
            points={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.points) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.points)}
            pointsy={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.pointsy) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.pointsy)}          
            post={users[uid]}
            following={
              this.props.followingData
                ? this.props.followingData[users[uid].userID]
                  ? true
                  : false
                : false
            }
            journalUserID={users[uid].userID}
            userIDlogged={this.props.userdata.userID}
            />
            :
   users[uid].companyID!=='-MloJFGCyJJbs_bNlwTg' && users[uid].userID!==this.props.userdata.userID ?         
        //  <ViewUser
         <ViewUser_gen
           src={users[uid].photoURL}
           id={users[uid].uid}
           companyName={users[uid].companyName}
           leaderArr={this.props.userdata.leaderArr}
           leaderID={users[uid].userID}
           slaveID={this.props.userdata.userID}
           companyID={this.props.userdata.companyID}
           firstName={this.props.userdata.firstName}
           lastName={this.props.userdata.lastName}
           uid={this.props.userdata.uid}
           leaderUid={users[uid].uid}
        
           //points={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.points) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.points)/100)}
           //pointsy={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.pointsy) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.pointsy)/100)}             
            points={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.points) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.points)}
            pointsy={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.pointsy) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.pointsy)}          
            post={users[uid]}
            following={
              this.props.followingData
                ? this.props.followingData[users[uid].userID]
                  ? true
                  : false
                : false
            }
            journalUserID={users[uid].userID}
            userIDlogged={this.props.userdata.userID}
            evalNum={this.props.userdata.evalNum ? this.props.userdata.evalNum : 0}
            evalNumP={this.props.userdata.evalNumP ? this.props.userdata.evalNumP : 0}
          /> 
          :
   users[uid].companyID!=='-MloJFGCyJJbs_bNlwTg' && users[uid].userID===this.props.userdata.userID ?         
         // <ViewUser_self
         <ViewUser_self_gen
           src={users[uid].photoURL}
           id={users[uid].uid}
           companyName={users[uid].companyName}
           leaderID={users[uid].userID}
           slaveID={this.props.userdata.userID}
           companyID={this.props.userdata.companyID}
           firstName={this.props.userdata.firstName}
           lastName={this.props.userdata.lastName}
           uid={this.props.userdata.uid}
           leaderUid={users[uid].uid}
       
           //points={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.points) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.points)/100)}
          // pointsy={this.props.userdata.pointsCalf ? ((Number(this.props.userdata.pointsy) + Number(this.props.userdata.pointsCalf))/100) : (Number(this.props.userdata.pointsy)/100)}             
           points={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.points) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.points)}
           pointsy={this.props.userdata.pointsCalf ? parseInt(this.props.userdata.pointsy) + parseInt(this.props.userdata.pointsCalf) : parseInt(this.props.userdata.pointsy)}          
           post={users[uid]}
           following={
             this.props.followingData
               ? this.props.followingData[users[uid].userID]
                 ? true
                 : false
               : false
           }
           journalUserID={users[uid].userID}
           userIDlogged={this.props.userdata.userID}
         /> :null
          ],
          users[uid].firstName ? users[uid].firstName : '',
          users[uid].lastName ? users[uid].lastName : '',
          // users[uid].department ? users[uid].department : "",
          // // users[uid].operation ? users[uid].operation : "",
          // users[uid].nationality ? users[uid].nationality : "",
          // users[uid].companyName ? users[uid].companyName : "",
          // users[uid].position ? users[uid].position : "",
          // //users[uid].points ? users[uid].points : "",
          // this.state.togglePoints ? users[uid].pointsy : users[uid].points,

         // this.state.togglePoints                        ? users[uid].pointsy : (users[uid].pointsCalf ? parseInt(users[uid].points) + parseInt(users[uid].pointsCalf) : parseInt(users[uid].points)),
          this.state.togglePoints && users[uid].pointsCalf ? (parseFloat(users[uid].pointsy) + parseFloat(users[uid].pointsCalf))/100 : (users[uid].pointsCalf ? (parseFloat(users[uid].points) + parseFloat(users[uid].pointsCalf))/100 : (parseFloat(users[uid].points))/100), 
         // users[uid].evalNum ? users[uid].evalNum : '',
          users[uid].evalNumP ? users[uid].evalNumP : '',
          users[uid].feedbackOn && showGFeedback && users[uid].sfeedback && (users[uid].sfeedback !==0) && (users[uid].sfeedback !==1) ? users[uid].sfeedback : 'n/a',
          users[uid].feedbackOn && showGFeedback && users[uid].feedback && (users[uid].feedback !==0) && (users[uid].feedback !==1) ? users[uid].feedback + [threeSixty]: 'n/a',
          users[uid].uid ? users[uid].uid : '',
          users[uid].userID ? users[uid].userID : ''
        ]
      })
      return dataListClone
    };

    // Mobile-optimized transformation function for essential fields only
    transformTableData_mobile_essential = () => {
      let { users } = this.props
      let nr
      let showGFeedback
      var threeSixty;

      let dataListClone = Object.keys(users).map((uid, index) => {
        if (users[uid].eval360 === true) { threeSixty = ' **' } else { threeSixty = '' }
        
        if (users[uid].gfeedbackOn === false) {
          if (users[uid].companyID === this.props.userdata.companyID) {
            showGFeedback = true
          } else {
            showGFeedback = false
          }
        } else {
          showGFeedback = true
        }

        nr = parseInt(uid) + parseInt(1)

        // Calculate Lc (points)
        let lcDisplay;
        if (users[uid].pointsCalf) {
          var pointsM = (parseInt(users[uid].points) + parseInt(users[uid].pointsCalf))/100 
          var pointsY = (parseInt(users[uid].pointsy) + parseInt(users[uid].pointsCalf))/100 
        } else {
          var pointsM = (parseInt(users[uid].points))/100 
          var pointsY = (parseInt(users[uid].pointsy))/100
        }
        lcDisplay = this.state.togglePoints ? pointsY : pointsM;

        // Individual name fields for mobile
        const firstName = users[uid].firstName || '';
        const lastName = users[uid].lastName || '';
        
        // Country
        const country = users[uid].nationality || '';
        
        // Level (position)
        const level = users[uid].position || '';
        
        // Feedback
        const feedbackDisplay = users[uid].feedbackOn && showGFeedback && users[uid].feedback && 
          (users[uid].feedback !== 0) && (users[uid].feedback !== 1) ? 
          users[uid].feedback + threeSixty : 'n/a';

        // Always show all 6 essential fields: #, Name, Lastname, Country, Level, Lc, Feedback
        return [
          nr,
          firstName,
          lastName,
          country,
          level,
          lcDisplay,
          feedbackDisplay
        ]
      })
      return dataListClone
    };

    render() {
      let { leaderboardData, users } = this.props
    
      // const getMuiTheme = () =>
      // createTheme({
      //   components: {
      //     tableBody: {
      //       "& > :not(:last-child)": {
      //        // borderBottom: "25px solid red",
      //         border: "0px solid red",
      //       }},
      //     MuiTableCell: {
      //       styleOverrides:{ root: {
      //         padding: '0px 1px 0px 0px',
      //         backgroundColor: '#CDCAC6',
      //         minWidth: '10px',
      //         Width: '10px',
      //         maxWidth: '10px',
      //         borderCollapse: 'separate',
      //         borderSpacing: '0px 0px'
      //       }}
      //     },
      //     MuiToolbar: {
      //       styleOverrides:{regular: {
      //         minHeight: '6px'
      //       }}
      //     }
      //   },
      //     overrides: {
      //       MUIDataTable: {
      //         root: {
      //           backgroundColor: '#FF000'
      //         },
      //         paper: {
      //           boxShadow: 'none'
      //         },
      //         responsiveScroll: {
      //           marginTop: '50px'
      //         }
      //       },
      //       MUIDataTableHeadCell: {
      //         root: {
      //           padding: '0px',
      //           verticalAlign: 'top!important',
      //           padding: '0px 1px 0px 0px'
      //         },
      //         head: {
      //           fontSize: '0.7rem',
      //           fontWeight: '500',
      //           padding: '0px 1px 0px 0px',
      //           verticalAlign: 'textTop',
      //           color: 'none'
      //         }
      //       },
      //       MUIDataTableBodyCell: {
      //         root: {
      //           borderBottom: '0px',
      //           fontSize: '0.70rem!important',
      //           whiteSpace: 'normal',
      //           wordWrap: 'break-word',
      //           overflowWrap: 'break-word',
      //          // padding: '0px 0px 0px 8px',
      //           padding: '0px 1px 0px 0px',
      //           color: 'black',
      //           minWidth: 5,
      //           borderCollapse: 'separate',
      //           borderSpacing: '0px 0px'
      //         }
      //       },
      //       MUIDataTableSelectCell: {
      //         root: {
      //           borderBottom: '0px',
      //           minWidth: '5px',
      //           Width: '10px',
      //           maxWidth: '5px',
      //           borderCollapse: 'separate',
      //           borderSpacing: '0px 0px'
      //         }
      //       },
      //       MUIDataTableHeadCell: {
      //         sortAction: {
      //           '& path': {
      //             color: '#000000', // or whatever you need
      //           }
      //         },
      //         sortActive: {
      //           color: '#ffffff' // whatever you need
      //         }
      //       },
      //       MUIDataTableToolbarSelect: {
      //         root: {
      //           display: 'inlineBlock'
      //         }
      //       }
      //     }
      //   })

      const getMuiTheme = () =>
      createTheme({
          overrides: {
            MUIDataTable: {
              root: {
                backgroundColor: '#FF000'
              },
              paper: {
                boxShadow: 'none'
              },
              responsiveScroll: {
                marginTop: '50px'
              }
            },
            MUIDataTableHeadCell: {
              root: {
                padding: '0px',
                verticalAlign: 'top!important'
              },
              head: {
                fontSize: '0.7rem',
                fontWeight: '500',
                padding: '0px',
                verticalAlign: 'textTop'
              }
            },
            MUIDataTableBodyCell: {
              root: {
                borderBottom: '0px',
                fontSize: '0.70rem!important',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                padding: '0px 1px 0px 0px'
              }
              // responsiveStacked: {
              //   height: "34px!important",
              //   fontSize: "0.70rem!important"
              // },
              // cellStacked: {
              //   height: "44px!important",
              //   fontSize: "0.70rem!important",
              //   // width: "50px!important",
              //   textAlign: "right!important"
              // }
            },
            MUIDataTableSelectCell: {
              root: {
                borderBottom: '0px'
              }
            },
            MUIDataTableToolbarSelect: {
              root: {
                display: 'inlineBlock'
              }
            }
          }
        });

      // const getMuiTheme = () =>
      // createTheme({
      //   components: {
      //     MuiTableCell: {
      //       styleOverrides:{ root: {
      //         padding: '8px',
      //         backgroundColor: '#CDCAC6',
      //         width: '300px',
      //         maxWidth: '300px'
      //       }}
      //     },
      //     MuiToolbar: {
      //       styleOverrides:{regular: {
      //         minHeight: '6px'
      //       }}
      //     }
      //   }
      // });

      // MUIDataTableHeadCell({
      //   sortAction: {
      //       '& path': {
      //         color: "#ffffff" // or whatever you need
      //       },
      //    },
      //   sortActive: {
      //     color: "#000000"  // whatever you need
      //   }
      // });

      const getMuiTheme_S = () =>
      createTheme({
          overrides: {
            MuiChip: {
              root: {
                backgroundColor: '#000000'
              }
            }
          }
        })

      return (
        <div>
          <div align='center'>
            { this.props.userdata.execmember ? null :
              <font color='green'>
                <a target='main' href='https://www.patreon.com/mevision' >Please PLEDGE in order to access all functions of Me-Vision Academy, including development plan, detailed feedback, earn MEV and more.</a>
              </font>
            }
          </div>
          {isMobile ?
            <TableContainer>
              <Table size="small" aria-label="a dense table">
                <TableHead height='30px'>
                  <TableRow />
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell> 
                       {/* style={{ fontSize: 10, flex: 1, flexDirection: 'row' }}> */}
                      <GenTutorial
                        // url={'https://youtu.be/FkavqYiH6v0'}
                        //url={'https://youtu.be/_Y4jOW71yJ8'}
                        url={'https://youtu.be/uIF_Ynheocg?feature=shared'}
                      />
                    </TableCell>
                    <TableCell style={{ fontSize: 14, fontWeight: '600', flex: 1, flexDirection: 'row' }}>
                      {this.state.togglePoints ? 'Annual: ' : 'All-time: '}
                    </TableCell>
                    <TableCell>
                      <ToggleButton
                        value={ this.state.togglePoints || false }
                        thumbStyle={{ borderRadius: '2px' }}
                        trackStyle={{ borderRadius: '2px' }}
                        onToggle={(value) => {
                          this.setState({
                            togglePoints: !value
                          })
                          this.loadLeaders('pointsy', !value)
                        }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
             Club:
                    </TableCell>
                    <TableCell>
                      <select value={this.state.selectedClub} onChange={this.handleChangeClub}>
                        <option value={this.props.userdata.companyID}>Local Forum</option>
                        <option value='x'>All Forums</option>
                      </select>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
             Country:
                    </TableCell>
                    <TableCell>
                      <select value={this.state.selectedCountry} onChange={this.handleChangeCountry}>
                        <option value='x'>All Countries</option>
                        {this.renderGeneralSettings('countriesb')}
                      </select>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
             Sector:
                    </TableCell>
                    <TableCell>
                      <select
                        onChange={this.handleChangeSector}
                        value={this.state.selectedSector}
                      >
                        <option value='x'>All Sectors / Divisions</option>
                        {this.renderSectorOptions()}
                      </select>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
             Position:
                    </TableCell>
                    <TableCell>
                      <select value={this.state.selectedPosition} onChange={this.handleChangePostion}>
                        <option value='x'>All Positions / Levels</option>
                        {this.renderGeneralSettings('position')}
                      </select>
                    </TableCell>
                  </TableRow>
                </TableBody>

              </Table>
            </TableContainer>
            :
            <TableContainer>
              <Table size="small" aria-label="a dense table">
                <TableHead height='1px' />
                <TableBody>
                  <TableRow>
                    <TableCell style={{ fontSize: 10, flex: 1, flexDirection: 'row' }}>
                      <GenTutorial
                       // url={'https://youtu.be/FkavqYiH6v0'}
                        url={'https://youtu.be/_Y4jOW71yJ8'}
                      />
                    </TableCell>
                    <TableCell style={{ fontSize: 10, flex: 1, flexDirection: 'row' }}>
                      {this.state.togglePoints ? 'Annual: ' : 'All-time: '}
                    </TableCell>
                    <TableCell>
                      <ToggleButton
                        value={ this.state.togglePoints || false }
                        thumbStyle={{ borderRadius: '2px' }}
                        trackStyle={{ borderRadius: '2px' }}
                        onToggle={(value) => {
                          this.setState({
                            togglePoints: !value
                          })
                          this.loadLeaders('pointsy', !value)
                        }}
                      />
                      {/* <ToggleButton
                     // value={ this.state.togglePoints ? false : true }
                      thumbStyle={{borderRadius: '2' }}
                      trackStyle={{borderRadius: '2' }}
                      onToggle={this.handleToggle(this.state.togglePoints)} /> */}
                    </TableCell>

                    <TableCell>
                      <select value={this.state.selectedClub} onChange={this.handleChangeClub}>
                        { this.state.selectedClub === 'xx'
                          ?
                          <option value={this.props.userdata.companyID} selected>Local Forum</option>
                          :
                          <option value={this.props.userdata.companyID}>Local Forum</option>
                        }

                        <option value='x'>All Forums</option>
                      </select>
                    </TableCell>
                    <TableCell>
                      <select value={this.state.selectedCountry} onChange={this.handleChangeCountry}>
                        <option value='x'>All Countries</option>
                        {this.renderGeneralSettings('countriesb')}
                      </select>
                    </TableCell>
                    <TableCell>
                      <select value={this.state.selectedSector} onChange={this.handleChangeSector}>
                        <option value='x'>All Sectors / Divisions</option>
                        {this.renderSectorOptions()}
                      </select>

                      {/* <select
                    onChange={handleChangeSector}
                    value={this.state.selectedSector}
                    style={{
                      width: 200,
                      height: 35,
                      color: 'gray',
                      paddingLeft: 5,
                      fontSize: 14,
                      border: 'none',
                      marginLeft: 10,
                    }}
                  >
                    <option value="x">All Sectors</option>
                    <option value="">
                      <em>None</em>
                    </option>
                    {this.props.companyValues &&
                      Object.keys(this.props.companyValues).map(id => {
                        const labelId = `${this.props.companyValues[id].valueID}`;
                        const labelName = `${this.props.companyValues[id].valueDesc}`;
                        let labelNamex = filterZZZ(labelName)
                        return (
                          (this.props.userdata.companyID==='-LjW7UI7e0uUikYrw-Vj')
                          ?
                          labelId!=='b4286108-a99d-46d4-bb9d-eacc64253bf0' &&
                          labelId!=='07ea19b6-19d1-4f42-b926-7579008945cd' &&
                          labelId!=='ea422d9b-fe94-4110-9db2-512c8e7607b9' &&
                          labelId!=='fca710c4-931c-4562-8e58-1a0eb1854a06' &&
                          labelId!=='89dac404-0800-41fd-b49d-7ac74c221106' &&
                          labelId!=='f6c65e5b-8b5f-4ce9-a01a-f1b9f60fc20e' &&
                          labelId!=='2fb61900-3569-4a63-ba00-36ffccf5612b'?
                          <option key={labelId} value={labelId}>{labelNamex}</option> : null
                          : <option key={labelId} value={labelId}>{labelNamex}</option>
                        );
                      })}
                  </select>                    */}
                    </TableCell>
                    <TableCell>
                      <select value={this.state.selectedPosition} onChange={this.handleChangePostion}>
                        <option value='x'>All Positions / Levels</option>
                        {this.renderGeneralSettings('position')}
                      </select>
                    </TableCell>
                    {/* <TableCell>
                  <Button
                    variant='contained'
                    onClick={this.loadLeaders.bind(this)}
                    autoFocus
                    type='submit'
                  >
                    Show List
                  </Button>
                  </TableCell> */}
                  </TableRow>
                </TableBody>

              </Table>
            </TableContainer>
          }
          <div />

          { (users && Object.keys(users).length > 0) ?
          <div style={{display: 'table', tableLayout:'fixed', width:'100%'}}>
            <MuiThemeProvider theme={getMuiTheme()}>
              <div className={isMobile ? 'mobile-leaderboard' : ''}>
                <MUIDataTable
                  key={`lb-${this.state.togglePoints ? 'year' : 'all'}`}
                  title={''}
                  data={isBrowser ? this.transformTableData() : this.transformTableData_mobile_essential()}
                  columns={isBrowser ? this.columns : this.columnsm}
                  options={this.options}
                  style={{ id: 'matrix' }}
                />
              </div>
            </MuiThemeProvider>
            </div>
            : null}
        </div>
      )
    }
}

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    followingData: state.userdata.followingButton,
    user_exists: state.users.userexists,
    company_settings: state.users.company_settings,
    general_settings: state.users.general_settings,
    leaderboardData: state.users.leaderboardData,
    users: state.users.users,
    companyValues: state.pldp.companyValues
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    getTopLeadersFromProps: params => dispatch(getTopLeadersFromProps(params)),
    getTopLeaders: params => dispatch(getTopLeaders(params)),
    showToast: params => dispatch(showToast(params)),
    getAllCompanySettings: params => dispatch(getAllCompanySettings(params)),
    getAllGeneralSettings: params => dispatch(getAllGeneralSettings(params)),
    fetchCompanyValues: params => dispatch(getCompanyValues(params))
    // leaderboardAll: params => dispatch(leaderboardAll(params))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(LeaderOnList)
